export class AddressZipCode {
    address: string;
    locality: string;
    uf: string;
}